import { Dropdown, Headline3 } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { CountryCode } from 'types/generatedSchemaTypes';
import { showFeatureFlag } from 'utils/featureFlagUtils';

type Country = {
  label: string;
  value: CountryCode;
};

type ApproveTermsSelectCountryProps = {
  country?: CountryCode;
  setSelectedCountry: (countryCode: CountryCode) => void;
  disabled?: boolean;
};

const DropdownIcon = () => <Icon name="Chevron_Down" />;
const CheckIcon = () => <Icon name="check" />;

const getCountries = (countryCodes: CountryCode[], t: any): Country[] => {
  return countryCodes.map((countryCode) => {
    return {
      label: t(`account.appLocations.${countryCode}`),
      value: countryCode,
    };
  });
};

const ApproveTermsSelectCountry: React.FC<ApproveTermsSelectCountryProps> = ({
  country,
  setSelectedCountry,
  disabled,
}) => {
  const { t } = useTranslation();
  const {
    flags: { show_norway },
  } = useContext(FeatureFlagsContext);
  const showNorway = showFeatureFlag(show_norway);

  // Create a country list based on feature flags
  const countries = useMemo(() => {
    const countryCodeList: CountryCode[] = ['FI', 'SE'];
    if (showNorway) {
      countryCodeList.push('NO');
    }
    return getCountries(countryCodeList, t);
  }, [showNorway, t]);

  return (
    <StyledWrapper mb={20}>
      <StyledWrapper mb={20}>
        <Headline3>{t('account.terms.approveTermsCountryHeader')}</Headline3>
      </StyledWrapper>
      <Dropdown
        testID="approve-terms-country-dropdown"
        items={countries}
        onSelect={(item) => setSelectedCountry(item.value as CountryCode)}
        placeholder={t('account.terms.approveTermsCountryPlaceholder')}
        dropdownIcon={DropdownIcon}
        checkIcon={CheckIcon}
        defaultItem={countries.find((item) => item.value === country)}
        disabled={disabled}
      />
    </StyledWrapper>
  );
};

export default ApproveTermsSelectCountry;
